import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/economics/nfish/title-icon.png'
import _imports_1 from '../../assets/images/economics/nfish/NFISH.png'
import _imports_2 from '../../assets/images/economics/nfish/token-pie-graph.png'
import _imports_3 from '../../assets/images/economics/nfish/fishing-graph.png'


const _withScopeId = n => (_pushScopeId("data-v-bc2cca1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nfish-container" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "title-img",
  src: _imports_0
}, null, -1))
const _hoisted_4 = { class: "nfish-section" }
const _hoisted_5 = { class: "desc-wrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "fish-icon",
  src: _imports_1
}, null, -1))
const _hoisted_7 = { class: "amount-row" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = { class: "name" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "value" }, "100,000,000", -1))
const _hoisted_11 = { class: "item" }
const _hoisted_12 = { class: "name" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "value" }, "0", -1))
const _hoisted_14 = { class: "item" }
const _hoisted_15 = { class: "name" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "value" }, "0", -1))
const _hoisted_17 = { class: "platform-row" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "icon-wrapper" }
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "info" }
const _hoisted_22 = { class: "name" }
const _hoisted_23 = {
  key: 0,
  class: "desc"
}
const _hoisted_24 = { class: "feature-section section" }
const _hoisted_25 = { class: "section-title" }
const _hoisted_26 = { class: "feature-list" }
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "token-section section" }
const _hoisted_29 = { class: "section-title" }
const _hoisted_30 = { class: "content-row" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "graph",
  src: _imports_2
}, null, -1))
const _hoisted_32 = { class: "desc-list" }
const _hoisted_33 = { class: "fishing-section section" }
const _hoisted_34 = { class: "section-title" }
const _hoisted_35 = { class: "content-row" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "graph",
  src: _imports_3
}, null, -1))
const _hoisted_37 = { class: "desc-list" }

import { PlatformItem, platformList } from '@/configs/home';
import { nFishFeatures, tokenProportion, fishingProportion } from '@/configs/economics/nfish';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const clickPlatform = (platform: PlatformItem) => {
  window.open(platform.link);
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(_ctx.$t('pageTitle')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", null, _toDisplayString(_ctx.$t('nFishDesc')), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('maxSupply')), 1),
          _hoisted_10
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('circulation')), 1),
          _hoisted_13
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('burned')), 1),
          _hoisted_16
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(platformList), (platform, index) => {
          return (_openBlock(), _createElementBlock("div", {
            onClick: ($event: any) => (clickPlatform(platform)),
            key: index,
            class: "platform"
          }, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("img", {
                class: "icon",
                src: platform.icon,
                alt: ""
              }, null, 8, _hoisted_20)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, _toDisplayString(platform.name), 1),
              (platform.desc)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(platform.desc), 1))
                : _createCommentVNode("", true)
            ])
          ], 8, _hoisted_18))
        }), 128))
      ]),
      _createVNode(_component_el_button, { class: "buy-btn black-btn" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('buy')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('feature')), 1),
      _createElementVNode("div", _hoisted_26, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(nFishFeatures), (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.name,
            class: "item"
          }, [
            _createElementVNode("img", {
              class: "img",
              src: item.img
            }, null, 8, _hoisted_27),
            _createElementVNode("div", null, _toDisplayString(_ctx.$t(item.name)), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('tokenEconomics')), 1),
      _createElementVNode("div", _hoisted_30, [
        _hoisted_31,
        _createElementVNode("div", _hoisted_32, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tokenProportion), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.name,
              class: "item"
            }, [
              _createElementVNode("i", {
                class: "iconfont icon-paw",
                style: _normalizeStyle({ color: item.iconColor })
              }, null, 4),
              _createTextVNode(" " + _toDisplayString(_ctx.$t(item.name)), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t('finishingEconomics')), 1),
      _createElementVNode("div", _hoisted_35, [
        _hoisted_36,
        _createElementVNode("div", _hoisted_37, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fishingProportion), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.name,
              class: "item"
            }, [
              _createElementVNode("i", {
                class: "iconfont icon-paw",
                style: _normalizeStyle({ color: item.iconColor })
              }, null, 4),
              _createTextVNode(" " + _toDisplayString(_ctx.$t(item.name)), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})